import Vue from 'vue';

export interface InterfaceMsalBroadcast {
  broadcast(type: string, payload: any): void;
}

class VueMsalBroadcast implements InterfaceMsalBroadcast {
  private bus: Vue;

  constructor() {
    this.bus = new Vue();
  }

  public broadcast(type: string, payload: any) {
    this.bus.$emit(type, payload);
  }

  public subscribe(type: string, callback: (payload: any) => void) {
    this.bus.$on(type, callback);
  }
}

export default new VueMsalBroadcast();
